import { Component, OnInit } from '@angular/core';
import {VgMediaElement} from '@videogular/ngx-videogular/core';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
